module.exports = __webpack_public_path__ + "static/media/fancygears-move.f5502cdd.gif";